import getRepoDocumentFields from 'api/v2/repository/getRepoDocumentFields';
import useQuery from 'hooks/react-query/useQuery';

import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';

const useDocumentFields = (documentId: string) => {
  return useQuery({
    queryKey: [DocumentsRepositoryCacheKeys.DocumentFields, documentId],
    queryFn: () => getRepoDocumentFields(documentId),
    enabled: !!documentId,
    select: (data) =>
      data.filter((field) => !!field.value && field.value !== 'null'),
  });
};

export default useDocumentFields;
